export function relative<
    Args extends unknown[],
    Result extends { url: string },
>(route: (...args: Args) => Result) {
    return (...args: Args): Result => {
        const result = route(...args);
        const url = new URL(result.url, 'http://wayfinder.invalid');
        return { ...result, url: url.pathname + url.search + url.hash };
    };
}
